// Calls & Callbacks mock data (approved HTML:
// 16-Calls-Callbacks-Consistency-Review-v5.html). Doug's world: Kixie
// Business Id 72616 is the authoritative provider; shared toll-free
// delivers the call. Warm vs direct transfer, exact-operation unknown
// recovery, and Finish-held-until-disposition stay distinct.

export type ConversationView = 'active' | 'noanswer' | 'voicemail' | 'unknown';

export interface CallGuideCopy {
  title: string;
  prompt: string;
}

export const CALL_GUIDE: CallGuideCopy = {
  title: 'Address & order follow-up',
  prompt: 'Thanks for calling, Sarah. Let’s confirm where your next barn order should go.',
};

export const CALL_INFO = {
  providerLabel: 'Kixie · Business Id 72616',
  providerEvidence: 'Example provider state',
  state: 'Connected',
  duration: '03:42',
  callerName: 'Sarah Mitchell',
  callerNumber: '(615) 555-0148',
  initials: 'SM',
};

export const PREPARED_REPLY =
  'Hi Sarah, I’m sorry one bottle arrived leaking. Let me get our Customer Service team the details.';

export const CONVERSATION_LABELS: Record<ConversationView, string> = {
  active: 'Phone call',
  noanswer: 'No answer',
  voicemail: 'Voicemail',
  unknown: 'Unknown caller',
};

export const NEXT_RECORD = {
  initials: 'AC',
  name: 'Alex Carter · Customer follow-up',
  description: 'Open the next eligible record after this work is confirmed.',
};
